import { useTranslation } from "react-i18next";

import { useRequiredContext } from "@lib/utils";
import { IconButton } from "@molecules";

import { useHaNLayoutMode } from "../state/layout/useHaNLayoutMode";
import { BuildingSelector } from "./BuildingSelector/BuildingSelector";
import { HaNContext } from "./HaNContext";

// The sidebar's title bar on wide screens; the app header row on phones, with the map/list toggle
export const HaNHeader = () => {
  const { t } = useTranslation();
  const { mobileView } = useRequiredContext(HaNContext);
  const layoutMode = useHaNLayoutMode();

  const showsMobileViewToggle = layoutMode === "mobile" && mobileView.canToggle;
  const isListView = mobileView.view === "list";

  return (
    <header className="col-start-1 row-start-2 flex h-[60px] items-center justify-between gap-2 border-b border-r bg-white px-5 max-sm:row-start-1 max-sm:border-r-0 max-sm:px-4">
      <BuildingSelector />
      {showsMobileViewToggle && (
        <IconButton
          className="flex-none"
          aria-label={isListView ? t("hereAndNow:Map") : t("hereAndNow:ListOfRooms")}
          icon={isListView ? "map" : "weekView"}
          iconButton="tertiary"
          onClick={mobileView.toggleView}
        />
      )}
    </header>
  );
};
